import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { KDialog } from 'components/core/KDialog'
import { KButton } from 'components/core/KButton'
import { TypeRoute } from 'core/TypeRoute'
import { useNavigateToSignIn } from 'hooks/AuthHooks'
import { styled } from '@mui/material/styles'
import { useDispatch } from 'react-redux'
import { setContinueAsGuest } from 'store/OrderingSlice'

const ActionButton = styled(KButton)(({ theme }) => ({
  minWidth: 200,
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    minWidth: 150,
  },
}))

export interface LoginSuggestionDialogProps {
  open: boolean
  onClose: () => void
  onContinueAsGuest: () => void
}

export const LoginSuggestionDialog = ({
  open,
  onClose,
  onContinueAsGuest,
}: LoginSuggestionDialogProps) => {
  const { t } = useTranslation()
  const navigateToSignIn = useNavigateToSignIn()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()

  const handleLoginClick = () => {
    onClose()
    navigateToSignIn(TypeRoute.Home)
  }

  const handleContinueAsGuest = () => {
    dispatch(setContinueAsGuest(true))
    onClose()
    onContinueAsGuest()
  }

  return (
    <KDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h4">{t('Please log in')}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mt: 1 }}>
          {t('Log in to save your details and speed up future checkouts')}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          paddingX: { xs: 2, sm: 3 },
          paddingBottom: { xs: 2, sm: 3 },
          paddingTop: { xs: 2, sm: 2 },
          gap: isMobile ? 1 : 0,
          justifyContent: 'center',
        }}
      >
        {!isMobile && <Box sx={{ flexGrow: 1 }} />}
        <ActionButton
          size="medium"
          variant="secondary"
          onClick={handleContinueAsGuest}
        >
          {t('Continue as guest')}
        </ActionButton>
        <ActionButton
          size="medium"
          onClick={handleLoginClick}
          sx={{
            marginLeft: isMobile ? '0 !important' : 2,
          }}
        >
          {t('Log in')}
        </ActionButton>
      </DialogActions>
    </KDialog>
  )
}
